import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  UserReferralTrackRequestSchema,
  UserReferralTrackRequestType,
  UserReferralTrackResponseSchema,
  UserReferralTrackResponseType
} from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseTrackReferralAttemptApiInterface {
  trackReferralAttemptApi: UseMutateAsyncFunction<
    UserReferralTrackResponseType,
    unknown,
    UserReferralTrackRequestType,
    unknown
  >;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: MutationStatus;
  reset: () => void;
}

const useTrackReferralAttemptApi = (): UseTrackReferralAttemptApiInterface => {
  const { paymentServices } = usePaymentServices();

  const trackReferralAttempt = (
    requestObject: UserReferralTrackRequestType
  ) => {
    try {
      UserReferralTrackRequestSchema.parse(requestObject);
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return paymentServices.trackReferralAttempt(requestObject).then((response) => {
      try {
        UserReferralTrackResponseSchema.parse(response);
      } catch (error) {
        console.error('Invalid response object:', error);
        throw error;
      }
      return response;
    });
  };

  const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
    trackReferralAttempt,
    {
      mutationKey: ['trackReferralAttemptApi']
    }
  );

  return {
    trackReferralAttemptApi: mutateAsync,
    isLoading,
    isError,
    error: error ? getAPIErrorMessage(error) : null,
    status,
    reset
  };
};

export { useTrackReferralAttemptApi };
